module.exports = __webpack_public_path__ + "static/img/peopleGame4.9a4d7c6.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/video/peopleGame4.webp
// module id = N+zH
// module chunks = 3